import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { metaForPath } from './meta';

// Ilk yuklemede head'i zaten prerender basiyor (scripts/prerender.js).
// Bu hook sadece client-side navigasyonda (Link tiklamasi, geri/ileri) head'i
// ayni kaynaktan gunceller ki SPA gezinmesi meta'yi bayatlatmasin.
export default function useSeo() {
    const { pathname } = useLocation();

    useEffect(() => {
        const meta = metaForPath(pathname);

        document.title = meta.title;

        setMeta('name', 'description', meta.description);
        setMeta('property', 'og:type', meta.ogType);
        setMeta('property', 'og:url', meta.canonical);
        setMeta('property', 'og:title', meta.title);
        setMeta('property', 'og:description', meta.description);
        setMeta('property', 'og:image', meta.ogImage);
        setMeta('property', 'og:image:secure_url', meta.ogImage);
        setMeta('property', 'og:image:type', meta.ogImageType);
        setMeta('property', 'og:image:width', meta.ogImageWidth);
        setMeta('property', 'og:image:height', meta.ogImageHeight);
        setMeta('property', 'og:image:alt', meta.ogImageAlt);
        setMeta('property', 'og:site_name', meta.siteName);
        setMeta('name', 'twitter:url', meta.canonical);
        setMeta('name', 'twitter:title', meta.title);
        setMeta('name', 'twitter:description', meta.description);
        setMeta('name', 'twitter:image', meta.ogImage);
        setMeta('name', 'twitter:image:alt', meta.ogImageAlt);

        setCanonical(meta.canonical);
        setRobots(meta.noindex);
    }, [pathname]);
}

function setMeta(attr, key, content) {
    if (!content) return;
    let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
}

function setCanonical(href) {
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
    }
    link.setAttribute('href', href);
}

// Sadece kendi ekledigi robots etiketini yonetir (data-seo="1").
// Staging build'i (NOINDEX=1) isaretsiz bir "noindex, nofollow" basiyor;
// client-side navigasyonda onu silmemek gerekiyor, yoksa test sitesi
// gezindikce indekslenebilir hale gelirdi.
function setRobots(noindex) {
    const managed = document.head.querySelector('meta[name="robots"][data-seo="1"]');

    if (!noindex) {
        if (managed) managed.remove();
        return;
    }

    if (managed) {
        managed.setAttribute('content', 'noindex, follow');
        return;
    }

    const tag = document.createElement('meta');
    tag.setAttribute('name', 'robots');
    tag.setAttribute('content', 'noindex, follow');
    tag.setAttribute('data-seo', '1');
    document.head.appendChild(tag);
}
